<template>
  <!-- 测试 -->
  <div class="box1">
    <div class="main-body"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  // 计算属性
  computed: {},
  methods: {},
};
</script>

<style scoped lang="less">
.box1 {
  display: flex;
  flex-direction: column;
}
.main-body {
  min-width: 1200px;
  min-height: 600px;
  margin: auto;
  margin-top: 20px;
  // background-image: url("../../../assets/imgs/img/blank.png");
  // background-size: 100% 100%;
}
</style>
